export default __webpack_public_path__ + "44c54fc21ab80055b1cc91b9a4f428f8.png";